/* eslint-disable no-throw-literal */
import type { ApolloClient } from '@apollo/client';
import type { Dispatch } from 'redux';
import { VALIDATE_TAX_ID } from '../graphql/queries';
import { TAX_ID } from '../constants/formFields';

const defaultResponse: { success: boolean } = { success: true };

const taxIdField = `${TAX_ID}`;

const validateTaxId = async (
  taxId: string,
  client: ApolloClient<object>,
): Promise<{ success: boolean }> => {
  try {
    const response = await client.query({ query: VALIDATE_TAX_ID, variables: { taxId } });

    return response.data.validateTaxId;
  } catch {
    return defaultResponse;
  }
};

export const doAsyncFormValidation = async (
  values: any,
  _dispatch: Dispatch,
  props: {
    client: ApolloClient<object>;
    isTaxIdValidationEnabled: boolean;
    setIsTaxIdValidating: (isValidating: boolean) => void;
    taxIdValidationFailedMessage: string;
  },
  fieldName: string,
) => {
  const { client, isTaxIdValidationEnabled, setIsTaxIdValidating, taxIdValidationFailedMessage } =
    props;

  if (!isTaxIdValidationEnabled) {
    return;
  }

  if (fieldName === taxIdField) {
    try {
      setIsTaxIdValidating?.(true);
      const { success } = await validateTaxId(values[taxIdField], client);

      if (!success) {
        throw { [taxIdField]: taxIdValidationFailedMessage };
      }
    } finally {
      setIsTaxIdValidating?.(false);
    }
  }
};
